import React, { useEffect, useMemo, useState } from "react";
import { Clock, Target, TrendingUp, ListChecks } from "lucide-react";
import BasicLineChart from "../SalesDirectory/BaseLineChart";
import BasicBars from "../SalesDirectory/BasicCharts";
import { SparkLineChart } from "@mui/x-charts/SparkLineChart";
import { useNavigate } from "react-router-dom";
import PieChartWithPaddingAngle from "../SalesDirectory/PieChart";
import ArcDesign from "../SalesDirectory/ArcDesign";
import ShinyBarChartHorizontal from "./HorizontalBarchart";
import SparkLine from "./SparkLineChart";

const FinanceMainDashboard = () => {
  const navigate = useNavigate();
  const COMPANYCODE = localStorage.getItem("companyCode");
  const DEPARTMENT = localStorage.getItem("currentSelectedDepartment");
  const APIPATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : [];
  const CURRENTUSEROBJECT = localStorage.getItem("currentUser")
    ? JSON.parse(localStorage.getItem("currentUser"))
    : [];
  const SALESPERSON = CURRENTUSEROBJECT[0]?.sales_man;
  const BASE_URL = APIPATHS[0]?.API_CONFIG;
  const [outStanding, setOutStanding] = useState([]);
  const [graphData, setGraphData] = useState([]);
  const [budgetPercentageExpense, setBudgetPercetnageExpense] = useState([]);
  const [budgetPercentageIncome, setBudgetPercetnageIncome] = useState([]);
  const [churnAnalysisData, setChurnAnalysisData] = useState([]);
  const [customerAcquisition, setCustomerAcquisition] = useState([]);
  const [loading, setLoading] = useState(true);
  const [myTaskCount, setMyTaskCount] = useState([]);
  const [engagementScore, setEngagementScore] = useState([]);

  const fetchOutStanding = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/api/CpaysCount/${COMPANYCODE}/FD_OUTSTANDING/1205/${DEPARTMENT}`,
        //internally setting the value 1205
      );

      const data = await response.json();

      if (Array.isArray(data) && data.length > 0) {
        const result = data[0];
        setOutStanding(result);
        const trendArray = [
          result.Days_0_to_30,
          result.Days_31_to_60,
          result.Days_61_to_90,
          result.Days_91_to_120,
          result.Over_120_Days,
          result.Total_Outstanding,
        ];
        setGraphData(trendArray);
      }
    } catch (error) {
      console.error("Failed to fetch dashboard data", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchBudgetPercentage = async (type) => {
    try {
      const response = await fetch(
        `${BASE_URL}/api/CpaysCount/${COMPANYCODE}/FD_BUDGETPERC/-/${type}`,
      );

      const data = await response.json();

      if (Array.isArray(data) && data.length > 0) {
        if (type === "EXPENSE") {
          setBudgetPercetnageExpense(data[0]);
        } else if (type === "INCOME") {
          setBudgetPercetnageIncome(data[0]);
        }
      }
    } catch (error) {
      console.error(`Failed to fetch ${type} budget percentage`, error);
    }
  };
  const fetchChurnAnalysis = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/api/CpaysCount/${COMPANYCODE}/FD_CHURN_ANALYSISGRAPH/-/-`,
        // {{BASE_URL}}/api/CpaysCount/SUNRISEWEB/FD_CHURN_ANALYSISGRAPH/-/-
      );

      const data = await response.json();

      if (Array.isArray(data) && data.length > 0) {
        const values = data?.map((item) => item.ChurnedCustomers);
        setChurnAnalysisData(values);
      }
    } catch (error) {
      console.error(`Failed to fetch Churn Analysis`, error);
    }
  };
  const fetchCustomerAcquisition = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/api/CpaysCount/${COMPANYCODE}/FD_CUSTOMERAcquisition/-/-`,
        // {{BASE_URL}}/api/CpaysCount/SUNRISEWEB/FD_CUSTOMERAcquisition/-/-
      );

      const data = await response.json();

      if (Array.isArray(data) && data.length > 0) {
        const values = data?.map((item) => item.NewClients);
        setCustomerAcquisition(values);
      }
    } catch (error) {
      console.error(`Failed to fetch Customer acquisition data`, error);
    }
  };
  const fetchMyTasks = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/api/CpaysCount/${COMPANYCODE}/SD_MYTASK/${SALESPERSON}/${DEPARTMENT}`,
        // {{BASE_URL}}/api/CpaysCount/SUNRISEWEB/FD_CUSTOMERAcquisition/-/-
      );

      const data = await response.json();
      console.log("My task count from finance dashboard", data);
      if (Array.isArray(data) && data.length > 0) {
        // const values = data?.map((item) => item.NewClients);
        // setCustomerAcquisition(values);
        setMyTaskCount(data[0]);
      }
    } catch (error) {
      console.error(`Failed to fetch Customer acquisition data`, error);
    }
  };
  const fetchEngagementScore = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/api/CpaysCount/${COMPANYCODE}/FD_ENGAGEMENTSCORE/-/-`,
        // {{BASE_URL}}/api/CpaysCount/SUNRISEWEB/FD_ENGAGEMENTSCORE/-/-
      );

      const data = await response.json();
      console.log("My task count from finance dashboard", data);
      if (Array.isArray(data) && data.length > 0) {
        setEngagementScore(data);
      }
    } catch (error) {
      console.error(`Failed to fetch Customer acquisition data`, error);
    }
  };
  useEffect(() => {
    fetchOutStanding();
    fetchBudgetPercentage("INCOME");
    fetchBudgetPercentage("EXPENSE");
    fetchChurnAnalysis();
    fetchCustomerAcquisition();
    fetchMyTasks();
    fetchEngagementScore();
  }, []);

  // Inside your component
  const totalNewClients = useMemo(() => {
    if (!customerAcquisition || customerAcquisition.length === 0) return 0;

    return customerAcquisition.reduce((sum, item) => {
      // Check if the property exists (check spelling/case)
      const val = item.NewClients ?? 0;
      return sum + Number(val);
    }, 0);
  }, [customerAcquisition]);

  console.log("Total New clients:", totalNewClients);
  // Calculate Total Churned Customers for Churn Analysis
  const totalChurned = churnAnalysisData?.reduce(
    (acc, curr) => acc + (curr.ChurnedCustomers || 0),
    0,
  );
  const onMyTaks = () => {
    navigate("/jobs");
  };
  return (
    <>
      <style jsx global>{`
        @keyframes rotate {
          from {
            transform: translate(-50%, -50%) rotate(0deg);
          }
          to {
            transform: translate(-50%, -50%) rotate(360deg);
          }
        }

        @keyframes rotate-reverse {
          from {
            transform: translate(-50%, -50%) rotate(0deg);
          }
          to {
            transform: translate(-50%, -50%) rotate(-360deg);
          }
        }

        .animate-rotate {
          animation: rotate 8s linear infinite;
        }

        .animate-rotate-reverse {
          animation: rotate-reverse 10s linear infinite;
        }
      `}</style>
      <div className="relative w-full overflow-hidden bg-gradient-to-br from-[#e6fff5] to-[#f0e8ff] flex items-start justify-center">
        <div
          className="absolute inset-0
      before:content-[''] before:absolute before:inset-0
      before:bg-[conic-gradient(from_0deg,#a7f3d0,#c7d2fe,#d9f99d,#a5f3fc,#c084fc,#d9f99d,#a7f3d0)]
      before:animate-rotate before:blur-[50px] before:opacity-75 before:scale-[2]
      before:-translate-x-1/2 before:-translate-y-1/2 before:left-1/2 before:top-1/2
      
      after:content-[''] after:absolute after:inset-0
      after:bg-[conic-gradient(from_0deg,#a7f3d0,#c7d2fe,#d9f99d,#a5f3fc,#c084fc,#d9f99d,#a7f3d0)]
      after:animate-rotate-reverse after:blur-[50px] after:opacity-55 after:scale-[1.8]
      after:-translate-x-1/2 after:-translate-y-1/2 after:left-1/2 after:top-1/2"
        />

        <div className="relative w-full z-10 flex flex-col items-start justify-between gap-8 px-4 py-10 ">
          <h2 className="text-4xl font-semibold ml-4 text-gray-700">
            Finance Dashboard
          </h2>
          <div className="grid w-full   grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
            <div
              onClick={onMyTaks}
              className="cursor-pointer flex flex-col items-center justify-between rounded-3xl bg-white p-6 text-center shadow-lg sm:p-8 bg-red-500"
            >
              <div className="flex flex-col items-center justify-center ">
                <h2 className="text-xl font-semibold   text-gray-700 lg:text-2xl">
                  My Tasks
                </h2>
                <ListChecks className="w-4 h-4 text-red-600 mt-2" />
              </div>

              <div className="mt-6">
                <p className="text-4xl font-light   text-black sm:text-5xl">
                  {myTaskCount?.CNT}
                  <span className="ml-2 text-xl font-medium text-gray-500">
                    total
                  </span>
                </p>
              </div>
            </div>
            <div className="flex w-full items-center justify-between rounded-3xl bg-slate-800 p-8 text-white shadow-xl">
              {/* Left Section */}
              <div className="flex flex-col">
                <h2 className="text-xl font-medium text-gray-400">
                  Total Outstanding
                </h2>
                <p className="mt-4 text-4xl font-bold">
                  {outStanding?.Total_Outstanding}
                </p>
              </div>

              <div className="h-24 w-1/2">
                <SparkLine
                  data={graphData}
                  color="#6366f1"
                  width={150}
                  height={96}
                />
              </div>
            </div>

            <div className="flex w-full items-center justify-between rounded-3xl bg-slate-800 p-8 text-white shadow-xl">
              {/* Left Section */}
              <div className="flex flex-col">
                <h2 className="text-xl font-medium text-gray-400">
                  Customer Acquisition
                </h2>
                <p className="mt-4 text-5xl font-bold">{totalNewClients}</p>
              </div>

              <div className="h-24 w-1/2">
                <SparkLine
                  data={customerAcquisition}
                  color="#6366f1"
                  width={150}
                  height={96}
                />
              </div>
            </div>

            <div className="flex w-full items-center justify-between rounded-3xl bg-slate-800 p-8 text-white shadow-xl">
              {/* Left Section */}
              <div className="flex flex-col">
                <h2 className="text-xl font-medium text-gray-400">
                  Churn Analysis
                </h2>
                <p className="mt-4 text-5xl font-bold">{totalChurned}</p>
              </div>

              <div className="h-24 w-1/2">
                <SparkLine
                  data={churnAnalysisData}
                  color="#6366f1"
                  width={150}
                  height={96}
                />
              </div>
            </div>
          </div>
          <div className="flex gap-4 w-full">
            <div className="w-1/2 shadow-lg rounded-3xl bg-white p-4">
              <h2 className="text-xl font-semibold   text-gray-700 ">
                Unpaid Amount (Top 10 Customers)
              </h2>
              <ShinyBarChartHorizontal />
            </div>
            <div className="w-1/2 shadow-lg rounded-3xl bg-white p-4">
              <h2 className="text-xl font-semibold   text-gray-700 ">
                {/* Target vs Achivement */}
              </h2>
              {/* <BasicBars /> */}
              <PieChartWithPaddingAngle />
            </div>
          </div>
          <div className="flex justify-center items-center w-full gap-4">
            <div className="w-full shadow-lg rounded-3xl bg-white p-4 ">
              <div className="h-[336px] overflow-y-auto">
                <h2 className="text-xl font-semibold   text-gray-700 ">
                  My Top Customers
                </h2>
                <div className="flex justify-between items-center my-2 border-b pb-2">
                  <p className="text-md text-gray-700 ">Al Noor Trading</p>
                  <p className="text-md text-gray-700 ">SAR 42,000</p>
                </div>
                <div className="flex justify-between items-center my-2 border-b pb-2">
                  <p className="text-md text-gray-700 ">Desert Tech</p>
                  <p className="text-md text-gray-700 ">SAR 31,500</p>
                </div>
                <div className="flex justify-between items-center my-2 border-b pb-2">
                  <p className="text-md text-gray-700 ">Desert Tech</p>
                  <p className="text-md text-gray-700 ">SAR 31,500</p>
                </div>
                <div className="flex justify-between items-center my-2 border-b pb-2">
                  <p className="text-md text-gray-700 ">Desert Tech</p>
                  <p className="text-md text-gray-700 ">SAR 31,500</p>
                </div>
                <div className="flex justify-between items-center my-2 border-b pb-2">
                  <p className="text-md text-gray-700 ">Desert Tech</p>
                  <p className="text-md text-gray-700 ">SAR 31,500</p>
                </div>
                <div className="flex justify-between items-center my-2 border-b pb-2">
                  <p className="text-md text-gray-700 ">Desert Tech</p>
                  <p className="text-md text-gray-700 ">SAR 31,500</p>
                </div>
                <div className="flex justify-between items-center my-2 border-b pb-2">
                  <p className="text-md text-gray-700 ">Desert Tech</p>
                  <p className="text-md text-gray-700 ">SAR 31,500</p>
                </div>
                <div className="flex justify-between items-center my-2 border-b pb-2">
                  <p className="text-md text-gray-700 ">Desert Tech</p>
                  <p className="text-md text-gray-700 ">SAR 31,500</p>
                </div>
              </div>
            </div>

            <div className="w-full shadow-lg rounded-3xl bg-white p-4 ">
              <div className="h-[336px] overflow-y-auto">
                <h2 className="text-xl font-semibold   text-gray-700 ">
                  My Top Customers
                </h2>
                <div className="flex justify-between items-center my-2 border-b pb-2">
                  <p className="text-md text-gray-700 ">Al Noor Trading</p>
                  <p className="text-md text-gray-700 ">SAR 42,000</p>
                </div>
                <div className="flex justify-between items-center my-2 border-b pb-2">
                  <p className="text-md text-gray-700 ">Desert Tech</p>
                  <p className="text-md text-gray-700 ">SAR 31,500</p>
                </div>
                <div className="flex justify-between items-center my-2 border-b pb-2">
                  <p className="text-md text-gray-700 ">Desert Tech</p>
                  <p className="text-md text-gray-700 ">SAR 31,500</p>
                </div>
                <div className="flex justify-between items-center my-2 border-b pb-2">
                  <p className="text-md text-gray-700 ">Desert Tech</p>
                  <p className="text-md text-gray-700 ">SAR 31,500</p>
                </div>
                <div className="flex justify-between items-center my-2 border-b pb-2">
                  <p className="text-md text-gray-700 ">Desert Tech</p>
                  <p className="text-md text-gray-700 ">SAR 31,500</p>
                </div>
                <div className="flex justify-between items-center my-2 border-b pb-2">
                  <p className="text-md text-gray-700 ">Desert Tech</p>
                  <p className="text-md text-gray-700 ">SAR 31,500</p>
                </div>
                <div className="flex justify-between items-center my-2 border-b pb-2">
                  <p className="text-md text-gray-700 ">Desert Tech</p>
                  <p className="text-md text-gray-700 ">SAR 31,500</p>
                </div>
                <div className="flex justify-between items-center my-2 border-b pb-2">
                  <p className="text-md text-gray-700 ">Desert Tech</p>
                  <p className="text-md text-gray-700 ">SAR 31,500</p>
                </div>
              </div>
            </div>
            {/* Arc Design  */}
            <div className=" shadow-lg rounded-3xl bg-white p-4 w-full">
              <h2 className="text-xl font-semibold text-gray-700 ">
                % of Income Budget
              </h2>
              <ArcDesign
                valueFromParent={50}
                colorFromParent={"#52b202"}
              />
            </div>
            <div className=" shadow-lg rounded-3xl bg-white p-4 w-full">
              <h2 className="text-xl font-semibold   text-gray-700 ">
                % of Expense Budget
              </h2>
              <ArcDesign
                valueFromParent={budgetPercentageExpense?.Percentage_of_Budget}
                colorFromParent={"#E1C253"}
              />
            </div>
          </div>
          {/* <div className="flex justify-center items-center w-full gap-4">

           <div className=" shadow-lg rounded-3xl bg-white p-4 w-full">
              <h2 className="text-xl font-semibold   text-gray-700 ">
                Sales Overview
              </h2>
              <ArcDesign />
            </div>
            <div className=" shadow-lg rounded-3xl bg-white p-4 w-full">
              <h2 className="text-xl font-semibold   text-gray-700 ">
                Sales Overview
              </h2>
              <ArcDesign />
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default FinanceMainDashboard;
